import React from 'react'
import styles from './LayerSelectorList.module.scss'
import LayerSelectorItem from './LayerSelectorItem/LayerSelectorItem'
import getLayerColour from '../../../helpers/getLayerColour'

const LayerSelectorList = (props) => {
  const { data, listChange, dataType, selectedState } = props

  const getNoLayers = () => {
    return ( <div className={styles.noLayers}>There is currently no layer data available</div>)
  }

  const handleClick = (event) => {
    listChange(event, 'click')
  }

  const handleRange = (values) => {
    listChange(values, 'range')
  }

  const opacityChange = (values) => {
    listChange(values, 'opacity')
  }

  const buildList = () => {

    const listItems = () => {
      const layers = data.map((layer, i) => {
          const layerColour = getLayerColour(layer.position)
          return (
            <LayerSelectorItem name={layer.Name} dataType={dataType} desc={layer.Desc} handleClick={handleClick} rangeChange={handleRange} opacityChange={opacityChange} selectedState={selectedState} layerColour={layerColour} itemCount={layer.count} key={i} />
          )
      })

      return layers
    }

    if (data.length === 0) {
      return (
        getNoLayers()
      )
    } else {
      return (
        <div className={styles.layerList}>{listItems()}</div>
      )
    }
  }

  return buildList()
}

export default LayerSelectorList